import { h } from 'vue';
import { ElInputNumber } from 'element-plus/es';
import 'element-plus/es/components/input-number/style/index';
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "corporate-information p-4"
};
const _hoisted_2 = {
  class: "content-box flex"
};
const _hoisted_3 = {
  class: "left-box relative"
};
const _hoisted_4 = {
  class: "ul-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "content overflow-y-auto max-h-[100%] whitespace-pre-wrap"
};
const _hoisted_7 = {
  class: "btn-box"
};
const _hoisted_8 = {
  key: 0,
  class: "loading-block"
};
const _hoisted_9 = {
  key: 1,
  class: "text-xs text-[#4E5969] flex items-center gap-2 mt-1"
};
const _hoisted_10 = {
  key: 0,
  class: "mt-4 w-full flex justify-end"
};
import { ref, computed, inject, onMounted, onUnmounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import initIncrementalUpdate from '@views/main/components/report-items/mixins/incrementalUpdate.mixin';
import { pubWorkflow, updateFileContent } from '../../api';
export default /*@__PURE__*/_defineComponent({
  __name: 'CorporateInformation',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const mainStore = useMainStore();
    const {
      incrementalMessageList,
      messageContentMap
    } = storeToRefs(mainStore);
    const props = __props;
    const curIndex = ref(0);
    const openSideEdit = inject('openSideEdit');
    const loading = ref(false);
    const isCustom = ref(false);
    const info = ref({
      dataList: [],
      companyInfo: {}
    });
    const btnLoading = ref(false);
    const failed = ref(false);
    const disabled = computed(() => {
      return mainStore.lastMsgId !== props.item.id;
    });
    const handleClick = index => {
      isCustom.value = true;
      curIndex.value = index;
    };
    const handleEdit = () => {
      openSideEdit({
        title: '企业基础信息',
        contentData: info.value.dataList,
        type: 'company_information',
        typeQuery: {
          active: curIndex.value
        },
        callBack: content => {
          // info.value = content
          const obj = {};
          info.value.dataList.forEach(item => {
            obj[item.name] = {
              标题: item.name,
              内容: item.content
            };
          });
          updateFileContent({
            id: info.value.companyInfo.id,
            fileContent: JSON.stringify(obj)
          }).then(() => {
            ElMessage.success('保存成功');
          });
        }
      });
    };
    const handleGenerateKnowledgeContent = async () => {
      // eslint-disable-next-line no-use-before-define
      const ret = await showInputNumberDialog();
      if (ret) {
        const params = {
          optType: 'GEN_KNOWLEDGE_CONTENT',
          sessionId: mainStore.msgParams.sessionId,
          companyInfoFileId: info.value.companyInfo.id,
          genCount: ret
        };
        try {
          await pubWorkflow(params);
          ElMessage.success('提交成功');
        } catch (error) {
          console.error('API调用失败:', error);
        } finally {}
      }
    };
    const showInputNumberDialog = () => {
      return new Promise((resolve, reject) => {
        const inputNumberValue = ref(5);
        ElMessageBox({
          title: '',
          message: () => h('div', [h('div', {
            style: 'margin-bottom: 8px;'
          }, '是否确认基于当前企业信息进行知识库生成操作？'), h('span', {
            style: 'margin-right: 10px;'
          }, '每个关键词生成'), h(ElInputNumber, {
            'modelValue': inputNumberValue.value,
            'min': 1,
            'max': 50,
            'step': 1,
            'controls': false,
            'onUpdate:modelValue': val => {
              inputNumberValue.value = val;
            }
          }), h('span', {
            style: 'margin-left: 10px;'
          }, '条'), h('div', {
            style: 'margin-top: 12px;'
          }, `按照本次生成语料库数量，预计消耗${info.value.keywordCount * (inputNumberValue.value || 0) * 1}点权益点`), h('div', {
            style: 'margin-top: 12px;'
          }, `权益结算规则：(${info.value.keywordCount}个关键词 * ${inputNumberValue.value || 0}篇语料 * 1点权益)`)]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          resolve(inputNumberValue.value);
        }).catch(() => {
          resolve();
        });
      });
    };
    const parseData = content => {
      try {
        const obj = JSON.parse(content);
        const arr = [];
        Object.entries(obj).forEach(([key, value]) => {
          arr.push({
            name: key,
            content: value['内容'] ? value['内容'] : value
          });
        });
        info.value.dataList = arr;
      } catch {
        info.value = {
          dataList: [],
          companyInfo: {}
        };
      }
    };
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      const incrementalData = message.incrementalData;
      if (incrementalData.content) {
        parseData(incrementalData.content.fileContent);
        info.value.companyInfo = incrementalData.content;
        loading.value = false;
        mainStore.loadNextMsg(props.item);
      } else if (!incrementalData.success) {
        failed.value = true;
      }
    });
    const handleGenerateCompanyInfo = async (retry = false) => {
      try {
        await ElMessageBox.confirm('本次任务消耗10点权益点，是否需要继续生成企业信息？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        failed.value = false;
        btnLoading.value = true;
        // 生成企业信息处理
        const params = {
          optType: 'GEN_COMPANY_INFO',
          sessionId: mainStore.msgParams.sessionId
        };
        if (retry) {
          params.messageId = props.item.id;
        }
        try {
          await pubWorkflow(params);
          ElMessage.success('提交成功');
          // if (retry) loading.value = true
        } catch (error) {
          console.error('API调用失败:', error);
        } finally {
          btnLoading.value = false;
        }
      } catch (error) {}
    };
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
    });
    onMounted(async () => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
      }
      try {
        info.value = props.content;
        if (info.value.companyInfo) {
          info.value.companyInfo.executeStatus = info.value.companyInfo.executeStatus || 1;
          loading.value = info.value.companyInfo.executeStatus === 1;
          const text = messageContentMap.value[props.item.id]?.[0]?.strFileContent;
          if (text) parseData(text);
        } else {
          loading.value = true;
        }
      } catch (error) {
        info.value = {
          dataList: [],
          companyInfo: {
            executeStatus: 1
          }
        };
      }
      // 处理增量数据
      if (props.item.incrementalIds) {
        props.item.incrementalIds.forEach(id => {
          handleIncrementalMessage(incrementalMessageList.value[id]);
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_i_home_full = _resolveComponent("i-home-full");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.dataList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: `${index}-${item.name}`,
          class: _normalizeClass({
            active: curIndex.value === index
          }),
          onClick: $event => handleClick(index)
        }, _toDisplayString(item.name), 11, _hoisted_5);
      }), 128))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "text-left mt-2 text-xs text-[#86909C]"
      }, [_createTextVNode(" 本次任务消耗 "), _createElementVNode("span", {
        class: "text-[#165DFF]"
      }, "10"), _createTextVNode(" 点权益 ")], -1))]), _createElementVNode("div", {
        class: _normalizeClass(["right-box relative", {
          'is-loading': loading.value
        }])
      }, [_createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(info.value.dataList?.[curIndex.value]?.content || '内容生成失败，请尝试重新生成') + " ", 1), __props.content && !_ctx.hideBtn && !disabled.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "footer-btn",
        onClick: handleEdit
      }, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_i_home_full, {
        class: "w-2 h-2"
      }), _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "ml-1"
      }, "查看/编辑", -1))])])) : _createCommentVNode("", true)])], 2), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [!failed.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "loader"
      }, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "text-xs text-[#4E5969] mt-1"
      }, "企业信息生成中…", -1))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[6] || (_cache[6] = _createTextVNode(" 企业信息生成失败 ", -1)), _createVNode(_component_el_button, {
        type: "text",
        loading: btnLoading.value,
        onClick: _cache[0] || (_cache[0] = $event => handleGenerateCompanyInfo(true))
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 重新生成 ", -1)]))]),
        _: 1
      }, 8, ["loading"])]))])) : _createCommentVNode("", true)]), !loading.value && !disabled.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_button, {
        loading: btnLoading.value,
        onClick: handleGenerateCompanyInfo
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("重新生成", -1)]))]),
        _: 1
      }, 8, ["loading"]), _createVNode(_component_el_button, {
        type: "primary",
        class: "render-btn",
        disabled: !info.value.dataList?.[curIndex.value]?.content,
        onClick: handleGenerateKnowledgeContent
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" 生成知识库 ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])) : _createCommentVNode("", true)]);
    };
  }
});